<div class="options-board-header">
	<div class="wrapper">
		<div class="type">
			@let isOptionTypeCall = optionsType() === optionTypeEnum.CALL;
			<app-button
				[appearance]="isOptionTypeCall ? 'positive' : 'flat'"
				size="s"
				(clicked)="setOptionsType(optionTypeEnum.CALL)"
			>
				{{ 'optionsBoardHeader.types.call' | translate }}
			</app-button>
			<app-button
				[appearance]="!isOptionTypeCall ? 'negative' : 'flat'"
				size="s"
				(clicked)="setOptionsType(optionTypeEnum.PUT)"
			>
				{{ 'optionsBoardHeader.types.put' | translate }}
			</app-button>
		</div>

		<div class="calendar-wrapper">
			@if (!isLoadingCalendar() && calendar().length) {
				<div class="calendar">
					<app-carousel>
						@for (optionDate of calendar(); track $index) {
							<app-button
								class="calendar-item"
								[appearance]="dateExpiration() === optionDate ? 'dark' : 'flat'"
								size="s"
								(clicked)="setDateExpiration(optionDate)"
							>
								{{ optionDate | date: 'dd.MM.yyyy' }}
							</app-button>
						}
					</app-carousel>
				</div>
			} @else if (isLoadingCalendar()) {
				<ng-container *ngTemplateOutlet="skeletonsCalendar" />
			}
		</div>
	</div>
</div>

<ng-template #skeletonsCalendar>
	<div class="skeletons-calendar">
		<div class="skeletons-calendar-wrapper">
			<div class="skeletons-calendar-wrapper-item">
				@for (skeleton of skeletons; track skeleton) {
					<div
						[tuiSkeleton]="true"
						class="skeletons-calendar-item"
					></div>
				}
			</div>
			<div class="skeletons-calendar-wrapper-item">
				<div
					[tuiSkeleton]="true"
					class="skeletons-calendar-item-mini"
				></div>
			</div>
		</div>
	</div>
</ng-template>
